import React, { useEffect, useRef, useState } from "react";
import EditFreebetFR, { EditFreebetRef } from "./EditFreebetFR";

const EditFreebet: React.FC = () => {
    const ref = useRef<EditFreebetRef>(null);
    return (
        <EditFreebetFR ref={ref} />
    );
}

export default EditFreebet;
